<script>
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Introduction from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Introduction.vue";
import KavehParsPageOne from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/PageOne.vue";
import KavehParsPageTwo from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/PageTwo.vue";
import KavehParsPageThree from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/PageThree.vue";
import FooladKavehPageOne from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/FooladKaveh/PageOne.vue";
import FooladKavehPageTwo from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/FooladKaveh/PageTwo.vue";
import FooladKavehPageThree from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/FooladKaveh/PageThree.vue";
import SimanTehranPageOne from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/SimanTehran/PageOne.vue";
import SimanTehranPageTwo from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/SimanTehran/PageTwo.vue";
import SimanTehranPageThree from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/SimanTehran/PageThree.vue";
import KashiCeramicSinaPageOne from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/KashiCeramicSina/PageOne.vue";
import KashiCeramicSinaPageTwo from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/KashiCeramicSina/PageTwo.vue";
import KashiCeramicSinaPageThree from "@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/KashiCeramicSina/PageThree.vue";
import html2pdf from 'html2pdf.js';

export default {
  components: {
    KavehParsPageOne, KavehParsPageTwo, KavehParsPageThree,
    FooladKavehPageOne, FooladKavehPageTwo, FooladKavehPageThree,
    SimanTehranPageOne, SimanTehranPageTwo, SimanTehranPageThree,
    KashiCeramicSinaPageOne, KashiCeramicSinaPageTwo, KashiCeramicSinaPageThree,
    Sidebar, Splash, Introduction,
  },
  methods: {
    async generatePDF() {
      await this.$nextTick();

      const components = [
        this.$refs.introduction?.$el,
        this.$refs.kavehParsPageOne?.$el,
        this.$refs.kavehParsPageTwo?.$el,
        this.$refs.kavehParsPageThree?.$el,
        this.$refs.fooladKavehPageOne?.$el,
        this.$refs.fooladKavehPageTwo?.$el,
        this.$refs.fooladKavehPageThree?.$el,
        this.$refs.simanTehranPageOne?.$el,
        this.$refs.simanTehranPageTwo?.$el,
        this.$refs.simanTehranPageThree?.$el,
        this.$refs.kashiCeramicSinaPageOne?.$el,
        this.$refs.kashiCeramicSinaPageTwo?.$el,
        this.$refs.kashiCeramicSinaPageThree?.$el,
      ];

      const pdfContainer = document.createElement("div");
      pdfContainer.style.display = "flex";
      pdfContainer.style.flexDirection = "column";
      pdfContainer.style.gap = "20px";

      for (let i = 0; i < components.length; i += 2) {
        const wrapper = document.createElement("div");
        wrapper.style.display = "block";

        if (i !== components.length - 1) {
          wrapper.style.pageBreakAfter = "always";
        }

        if (components[i]) {
          this.replaceCanvasesWithImages(components[i]);
          wrapper.appendChild(components[i].cloneNode(true));
        }

        if (components[i + 1]) {
          this.replaceCanvasesWithImages(components[i + 1]);
          wrapper.appendChild(components[i + 1].cloneNode(true));
        }

        pdfContainer.appendChild(wrapper);
      }

      html2pdf().from(pdfContainer).set({
        margin: 10,
        filename: "گزارش بررسی عملکرد اقتصادی هلدینگ گسترش صنایع معدنی کاوه پارس.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
        },
        jsPDF: { unit: "mm", format: "a3", orientation: "portrait" },
      }).save();

      pdfContainer.remove();
    },
    replaceCanvasesWithImages(element) {
      const canvases = element.querySelectorAll("canvas");
      canvases.forEach((canvas) => {
        const img = document.createElement("img");
        img.src = canvas.toDataURL("image/png");
        img.style.width = "100%";
        img.style.height = "auto";
        canvas.parentNode.replaceChild(img, canvas);
      });
    },
  },
};
</script>

<template>
  <button @click="generatePDF" class="btn btn-primary btn-submit-1 custom-p-2 btn-download">
    دانلود PDF گزارشات
  </button>
  <div class="pdf-container" ref="pdfContainer">
    <!-- Introduction -->
    <Introduction ref="introduction" style="height: 190mm" />
    <!-- KavehPars -->
    <KavehParsPageOne ref="kavehParsPageOne" style="height: 190mm" />
    <KavehParsPageTwo ref="kavehParsPageTwo" style="height: 190mm" />
    <KavehParsPageThree ref="kavehParsPageThree" style="height: 190mm" />
    <!-- FooladKaveh -->
    <FooladKavehPageOne ref="fooladKavehPageOne" style="height: 190mm" />
    <FooladKavehPageTwo ref="fooladKavehPageTwo" style="height: 190mm" />
    <FooladKavehPageThree ref="fooladKavehPageThree" style="height: 190mm" />
    <!-- SimanTehran -->
    <SimanTehranPageOne ref="simanTehranPageOne" style="height: 190mm" />
    <SimanTehranPageTwo ref="simanTehranPageTwo" style="height: 190mm" />
    <SimanTehranPageThree ref="simanTehranPageThree" style="height: 190mm" />
    <!-- KashiCeramicSina -->
    <KashiCeramicSinaPageOne ref="kashiCeramicSinaPageOne" style="height: 190mm" />
    <KashiCeramicSinaPageTwo ref="kashiCeramicSinaPageTwo" style="height: 190mm" />
    <KashiCeramicSinaPageThree ref="kashiCeramicSinaPageThree" style="height: 190mm" />
  </div>
</template>

<style scoped>
.pdf-container {
  height: 0;
  overflow: hidden;
}
.btn-download {
  font-size: 0.8rem;
  padding: 1rem;
  min-width: 9vw;
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
}
.btn-download:focus {
  color: white;
  background: #3742FA;
}
</style>
